export const formatMeasurementLabel = (name: string | null | undefined, description?: string | null): string => {
  const normalizedName = name?.trim() ?? "";
  const normalizedDescription = description?.trim() ?? "";

  if (!normalizedName) {
    return normalizedDescription;
  }

  return normalizedDescription && normalizedDescription !== normalizedName
    ? `${normalizedName} (${normalizedDescription})`
    : normalizedName;
};
